/* eslint-disable */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import {
    Box,
    // CircularProgress,
    Slide,
} from '@mui/material';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
import { useAuthState } from '../../stores/authStore';
import { updateModuleState, useEventState } from '../../stores/eventStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
    REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import AppConstants from '../../constants/appConstants';
import { isEmpty } from 'lodash-es';
import HotelSettingsDialog from '../../sharedcomponents/userList/hotelSettingsDialog';
import AzureConstant from '../../config/authConfigConstant';
import AddGreenRoomDialog from './addGreenRoomDialog';

// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const headers = [
    { key: 'name', title: 'Full Name' },
    { key: 'email', title: 'Email' },
    { key: 'phone', title: 'Phone' },
    { key: 'relation', title: 'Relation' },
    { key: 'submittedBy', title: 'Audit By' },
    { key: 'submittedDate', title: 'Audit Date' },
    { key: 'auditStatus', title: 'Audit Status' },
    { key: 'requestStatus', title: 'Status' },
];

const GreenRoomList = (props) => {
    const showSearch = true;
    const openDialog = useState(false);
    //const transittype = useState(null);

    const history = useHistory();
    const authState = useAuthState();
    const eventState = useEventState();
    const loading = useState(true);
    const allData = useState(null);
    const fullData = useState([]);
    const allListData = useState();
    const eventData = useState(null);
    const userID = useState(null);
    const displayName = useState(null);
    const [allNoteValue, setAllNoteValue] = React.useState('');
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const requestPending = useState(null);
    const [showHistory, setShowHistory] = React.useState(false);
    const [hotelHistory, setHotelHistory] = React.useState();
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const filteredEmty = useState(false);
    const filteredList = useState([]);
    const [participantList, setParticipantList] = React.useState(null);
    const allNote = useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const addCredentialDialog = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    const exportDocumentLoader = useState(false)

    const [modPermission, setModPermission] = React.useState(null);
    const [credData, setCredData] = React.useState(null);

    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const [userActivityExcelLoader, setUserActivityExcelLoader] =
        React.useState(false);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');

    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }
    useEffect(() => {
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.GREENROOM).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'GREENROOM')
                    );
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminGreenRoomRequestList();
                // getParticipantList();
            }
            getParticipantList();
        }
    }, [modPermission]);
    const getAdminGreenRoomRequestList = () => {
        let participantList = [];
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_GREENROOMS(
                eventData.get().eventID,
                userInfo.userType == 'Admin' || !isEmpty(eventRole)
                    ? true
                    : false,
                userInfo.userID
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let allrequestData = [];
                    let requestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        const indexOfLastRecord =
                            pagingInfo.get().currentPage *
                            pagingInfo.get().itemsPerPage;
                        const indexOfFirstRecord =
                            indexOfLastRecord - pagingInfo.get().itemsPerPage;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            let hotelSettingData = [];
                            let hotelSettingRemainingcount = [];
                            if (
                                item.greenRoomSetting !== undefined &&
                                item.greenRoomSetting.length > 0
                            ) {
                                const parseData = JSON.parse(
                                    item.greenRoomSetting[0].setting
                                );
                                if (
                                    parseData !== undefined &&
                                    parseData.length > 0
                                ) {
                                    const settingParseData = JSON.parse(
                                        parseData[0].GreenRoomSetting
                                    );
                                    hotelSettingData.push(settingParseData);
                                    hotelSettingRemainingcount.push({
                                        used:
                                            Number(
                                                item.greenRoomSetting[0]
                                                    .actualGreenRoomCount
                                            )
                                    });
                                }
                            }
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'greenRoomID',
                                        greenRoomID: item.greenRoomID,
                                        width: '0.05',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.1',
                                        showLabel: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                    },
                                    {
                                        label: 'Pre Draft Introduction',
                                        key: 'preDraftIntroduction',
                                        preDraftIntroduction: item.preDraftIntroduction,
                                        width: '0.1',
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Submitted Date',
                                        key: 'createdDate',
                                        createdDate: !Helper.IfDateIsNULL(
                                            item.createdDate
                                        )
                                            ? Helper.FormatDate(
                                                item.createdDate
                                            )
                                            : '',
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'CredAllotment',
                                        key: 'credentialAllotment',
                                        hotelSettingData:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData
                                                : 0,
                                        hotelSettingRemainingcount:
                                            hotelSettingRemainingcount.length >
                                                0
                                                ? hotelSettingRemainingcount
                                                : 0,
                                        showLabel: false,
                                        width: '0.2',
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'History',
                                        key: 'auditHistory',
                                        auditHistory: '',
                                        width: '0.05',
                                        showLabel: false,
                                        showChips: false,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.1',
                                        showLabel: false,
                                        showStatusIcon: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.15',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                ],
                                selected: false,
                            });
                        });
                        fullData.set(allrequestData);
                        setFilters({
                            participant: participantList,
                            requestStatus: statusList.attach(Downgraded).get(),
                        });

                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    } else {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(false);
                    }
                    allData.set(allrequestData);
                    allListData.set(allrequestData);
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                data.length / pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                console.log("error", error);
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const callExport = () => {
        // const gridData = allData.get();
        // if (gridData.length > 0) {
        if (filteredList.attach(Downgraded).length !== 0 || filteredEmty.get() === true) {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = fullData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
        // }
        // else
        // {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please add request first.',
        //     });
        // }
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item);
    };
    const handleConfirmation = () => {
        let deleteRequests = [];
        fullData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.greenRoomID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_GREENROOM, {
            greenRoomIDs: deleteRequests.join(','),
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    //props.onDelete(false);
                    setAll.set(false);
                    getAdminGreenRoomRequestList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handlePendingAction = () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const req = requestPending.attach(Downgraded).get();
        const updateStatus = {
            greenRoomID: req.greenRoomID,
            status: req.status,
            modifiedBy: userInfo.userID,
            eventID: eventData.get().eventID,
            userID: req.userID,
            note: "",
        };
        ApiHelper.post(
            APIURLConstants.UPDATE_GREENROOM_STATUS,
            updateStatus
        ).then((res) => {
            if (res.data) {
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                approveloading.set({
                    loading: false,
                    index: 0
                })
                pendingAction.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                requestPending.set(null);
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request updated successfully',
                });
                getAdminGreenRoomRequestList();
            }
        });
    };

    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let HotelBookingIDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.greenRoomID);
            });
            HotelBookingIDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export, {
            EventID: eventData.get().eventID,
            ModuleID: 28,
            IDs: HotelBookingIDs
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `GreenRoom-Report`);
                }
            }
        });
    };

    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getAdminGreenRoomRequestList();
    };
    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...fullData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.greenRoomID == item.actualData.greenRoomID
        );
        let newItem = newData[Index];

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            greenRoomID: newItem.actualData.greenRoomID,
            status: isStatus,
            userID: newItem.actualData.userID,
            action,
            note: newItem.note,
            item: newItem.actualData,
        });
        openNoteDialog.set(true);
    };

    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    const renderDialogContent = () => {
        return <StyledTable1 rowHeader={headers} data={hotelHistory} />;
    };

    const renderDialogActions = () => { };
    const getHotelHistory = (id) => {
        ApiHelper.get(APIURLConstants.GET_GREENROOM_HISTORY(id)).then(
            (res) => {
                let arr = []
                setHotelHistory([]);
                res.data.map((item, index, originalArr) => {
                    let previous = originalArr[index - 1];
                    arr.push({
                        actualData: item,
                        row: [
                            {
                                name: item.contactName,
                                highlight:
                                    index > 0
                                        ? previous?.contactName !== item.contactName
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                email: item.contactEmail,
                                highlight:
                                    index > 0
                                        ? previous?.contactEmail !== item.contactEmail
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                phone: item.contactNo,
                                highlight:
                                    index > 0
                                        ? previous?.contactNo !== item.contactNo
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                relation: item.relationName,
                                highlight:
                                    index > 0
                                        ? previous?.relationName !== item.relationName
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                submittedBy: item.submittedBy
                                    ? item.submittedBy
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.submittedBy !== item.submittedBy
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                submittedDate: item.submittedDate
                                    ? Helper.FormatDateTime(item.submittedDate)
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.submittedDate !==
                                            item.submittedDate
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                auditStatus: item.auditStatus
                                    ? item.auditStatus
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.auditStatus !== item.auditStatus
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                requestStatus: item.requestStatus
                                    ? item.requestStatus
                                    : '',
                                highlight:
                                    index > 0
                                        ? previous?.requestStatus !==
                                            item.requestStatus
                                            ? true
                                            : false
                                        : false,
                            },
                        ],
                    });
                });
                setHotelHistory(arr);
            });
    };
    const showHotelHistory = (item) => {
        setShowHistory(true);
        getHotelHistory(item.actualData.greenRoomID);
    };
    const getParticipantList = () => {
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    };

    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        newRequestNote['item'].note = value;
        const notesUpdate = {
            greenRoomID: newRequestNote.greenRoomID,
            note: newRequestNote.note,
            Status: newRequestNote.status,
            ModifiedBy: userID.get(),
            eventID: eventInfo.eventID,
            userID: newRequestNote.userID
        };

        ApiHelper.post(
            APIURLConstants.UPDATE_GREENROOM_STATUS,
            notesUpdate
        )
            .then(async (res) => {
                if (res.data) {
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });

                    getAdminGreenRoomRequestList();
                    if (eventData.get().readonlyOrHide === 0) {
                        saveAppNotification(newRequestNote);
                    }
                    closeNoteDialog();
                }
            })
            .catch((err) => {
                approveloading.set({
                    loading: false,
                    index: 0
                })
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                console.log(err);
            });
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.userID),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: 28,
            recordRefID: obj.greenRoomID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad)
            .then((res) => {
                ApiHelper.get(
                    APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                        obj.userID,
                        eventData.get().eventID,
                        eventData.get().eventName,
                        displayName.get(),
                        obj.status === 2 ? "Approved" : obj.status === 3 ? "Rejected" : "Pending"
                    )
                ).then((res) => {
                    console.log(res);
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    //// After Completed New Request Page Then Un Commet
    const redirectToEditHotelRequest = (data) => {
        setCredData(data.actualData)
        setTimeout(() => {
            addCredentialDialog.set({
                open: true,
                title: '',
                OkButtonText: 'Update',
            });
        }, 500);

    };

    const onAddRequest = () => {
        setCredData(null)
        // const path = generatePath(RouteConstants.CREATE_GREEN_ROOM, {
        //     eventID: eventInfo.eventID
        // });

        // history.push({
        //     pathname: path,
        //     state: { participantList: parti}
        // });

        // state: { participantList: filteredParticipants, adminUser: true },
        addCredentialDialog.set({
            open: true,
            title: '',
            OkButtonText: 'Submit',
        });
    };
    const filterListData = (data) => {
        if (data.length == 0) {
            filteredEmty.set(true);
        } else {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
    const onDelete = () => {
        // const selected = allData.get().filter((user) => user.selected === true);
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const onPendingAction = (item, index) => {
        if (item.actualData.status == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.status == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...fullData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.greenRoomID == item.actualData.greenRoomID
        );
        let newItem = newData[Index].actualData;
        console.log("newItem", newItem);
        const isStatus = 1;
        requestPending.set({
            addedFor: item.actualData.addedFor,
            status: isStatus,
            userID: newItem.userID,
            greenRoomID: newItem.greenRoomID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };

    const exportGreenRoomImage = async () => {
        // console.log("asdasd");
        const selected = fullData
            .get()
            .filter((user) => user.selected === true);

        if (selected.length > 0) {
            setUserActivityExcelLoader(true);
            let playerIds = [];
            selected &&
                selected.length > 0 &&
                selected.map((key) => {
                    playerIds.push(key.actualData.greenRoomID);
                });

            let RETURN_URL = AzureConstant.LOCAL_APP;
            exportDocumentLoader.set(true)
            if (window.location.href.includes(AzureConstant.DEV_APP)) {
                RETURN_URL = 'https://' + AzureConstant.DEV_APP;
            }
            if (window.location.href.includes(AzureConstant.QA_APP)) {
                RETURN_URL = 'https://' + AzureConstant.QA_APP;
            }
            if (window.location.href.includes(AzureConstant.CT_APP)) {
                RETURN_URL = 'https://' + AzureConstant.CT_APP;
            }
            if (window.location.href.includes(AzureConstant.PROD_APP)) {
                RETURN_URL = 'https://' + AzureConstant.PROD_APP;
            }
            let MAIN_URL = window.location.href.includes(AzureConstant.LOCAL_APP) ? RETURN_URL : RETURN_URL + '/'
            fetch(
                MAIN_URL +
                APIURLConstants.DOWNLOAD_PROFILE_PIC_GREENROOM(
                    eventData.attach(Downgraded).get().eventID
                ),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Bearer ' + Helper.getStorage('accessToken'),
                    },
                    body: JSON.stringify(playerIds),
                }
            )
                .then((res) => res.blob())
                .then((blob) => {
                    exportDocumentLoader.set(false)
                    saveAs(blob, 'ParticipantProfilPic.zip');
                    setUserActivityExcelLoader(false);
                }) // saveAs is a function from the file-saver package.
                .catch((err) => {
                    exportDocumentLoader.set(false)
                    console.log(err.message);
                });
        } else {
            setUserActivityExcelLoader(false);
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select at least one record.',
            });
        }


        // if (selected1.length === 0) {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please select request first',
        //     });
        // } else {
        //     let message = setAll.get()
        //         ? 'Do you want to Approve all request?'
        //         : 'Do you want to Approve selected request?';
        //     allNote.set(true);
        //     approveConfirmation.set({
        //         open: true,
        //         title: '',
        //         OkButtonText: 'Ok',
        //         message: message,
        //     });
        // }


    }
    const multiApprove = () => {
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true);
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const multiReject = () => {
        const selected1 = fullData
            .get()
            .filter((user) => user.selected === true);
        if (selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true);
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handleRejectConfirmation = () => {
        let rejectRequests = [];
        fullData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.greenRoomID,
                    transportType: 'GreenRoom'
                });
            }
        });
        rejectLoader.set(true);
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS,
            {
                Ids: JSON.stringify(rejectRequests),
                Status: 3,
                Note: allNoteValue,
                EventID: eventInfo.eventID,
                ModuleID: 28,
                ModifiedBy: userID.value,
                TemplateType: "GreenRoom",
                TransportType: "",
                appNotificationTypeID: 1
            }
        )
            .then(async (res) => {
                if (res.data) {
                    rejectLoader.set(false);
                    await updateModuleState();
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue('')
                    getAdminGreenRoomRequestList();
                }
            })
            .catch((error) => {
                rejectLoader.set(false);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while reject request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleApproveConfirmation = () => {
        let approveRequests = [];
        fullData.get().map((row) => {
            if (row.selected === true) {
                //console.log(row.actualData)
                approveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.greenRoomID,
                    transportType: 'GreenRoom'
                });
            }
        });
        // console.log("approveRequests",approveRequests);
        // return false
        approveLoader.set(true);
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS,
            {
                Ids: JSON.stringify(approveRequests),
                Status: 2,
                Note: allNoteValue,
                EventID: eventInfo.eventID,
                ModuleID: 28,
                ModifiedBy: userID.value,
                TemplateType: "GreenRoom",
                TransportType: "",
                appNotificationTypeID: 1
            }
        )
            .then(async (res) => {
                if (res.data) {
                    approveLoader.set(false);
                    await updateModuleState();
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });

                    setAll.set(false);
                    setAllNoteValue('')
                    getAdminGreenRoomRequestList();
                }
            })
            .catch((error) => {
                console.log("error", error);
                approveLoader.set(false);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while approve request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onSettingClick = () => {
        openDialog.set(true);
    };
    const handleClose = () => {
        openDialog.set(false);
    };

    const onToggleChange = (item, findex) => {
        item.expanded = !item.expanded;

        let index = allData.findIndex(i => i.actualData.greenRoomID === item.actualData.greenRoomID);
        allData[index].set(item);

        let newIndex = fullData.findIndex(i => i.actualData.greenRoomID === item.actualData.greenRoomID);
        fullData[newIndex].set(item);
    }
    return (
        <Box sx={{ width: '100%' }}>
            {
                // loading.get() ? (
                //     <Box style={loader}>
                //         <CircularProgress />
                //     </Box>
                // ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <AccordianCommonRequests
                        // new props
                        data={allData.attach(Downgraded).get()}
                        allData={fullData.attach(Downgraded).get()}
                        editRow={redirectToEditHotelRequest}
                        handleClick={onAddRequest}
                        title={''}
                        buttonTitle={'Add'}
                        deleteRows={onDelete}
                        showSearch={showSearch}
                        filterChangeVal={filterChangeVal}
                        loading={loading.get()}
                        searchLabel={'Search'}
                        showFilter={true}
                        filters={filters}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        onActionClick={onActionClick}
                        showSync={true}
                        showHistory={showHotelHistory}
                        showExport={true}
                        callExport={callExport}
                        getResults={getAdminGreenRoomRequestList}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        handlePageChange={handlePageChange}
                        isPage={true}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        moduleToShow={'GreenRoom'}
                        moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.get().moduleDetails : [],
                            AppConstants.EVENT_MODULES.GREENROOM)}
                        showRequestStatus={showStatus}
                        multiApprove={multiApprove}
                        multiReject={multiReject}
                        showApproveAndReject={true}
                        exportDocuments={exportGreenRoomImage}
                        showExportDocuments={true}
                        onSettingClick={onSettingClick}
                        approveLoader={approveLoader.get()}
                        rejectLoader={rejectLoader.get()}
                        approveloading={approveloading.get()}
                        rejectloading={rejectloading.get()}
                        exportDocumentsLoader={exportDocumentLoader.get()}
                        hideModuleInfo={true}
                        windowAccordDataList={true}
                        rowType="greenroom"
                        onToggleChange={onToggleChange}
                    />
                )
            }
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {showHistory && (
                <CustomDialog
                    TransitionComponent={Transition}
                    title={'GreenRoom History'}
                    maxWidth="xl"
                    handleClose={() => {
                        setShowHistory(false);
                        setHotelHistory([]);
                    }}
                    showClose={true}
                    open={showHistory}
                    fullWidth={true}
                    renderContent={renderDialogContent}
                    renderActions={renderDialogActions}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <AddGreenRoomDialog
                    open={addCredentialDialog.get().open}
                    message={addCredentialDialog.get().message}
                    OkButtonText={addCredentialDialog.get().OkButtonText}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    credData={credData}
                    onCancelClick={() => {
                        setCredData(null)
                        addCredentialDialog.set({
                            ...addCredentialDialog.get(),
                            open: false,
                        });
                    }}
                    participantList={participantList}
                    modPermission={modPermission}
                    getAdminGreenRoomRequestList={getAdminGreenRoomRequestList}
                ></AddGreenRoomDialog>
            }
            {/* {openAllNoteDialog.get() && (
                <AdminNote
                    open={openAllNoteDialog.get()}
                    title={`${requestAllNote.get().action} Note`}
                    handleClose={closeNoteDialogAll}
                    updateNote={updateNoteAll}
                    data={requestAllNote.attach(Downgraded).get()}
                />
            )} */}
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {openDialog.get() && (
                <HotelSettingsDialog
                    open={openDialog.get()}
                    title="Add Settings"
                    handleClose={handleClose}
                    users={eventParticipants.attach(Downgraded).get()}
                    snackBarProps={props.snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getParticipants={getAdminGreenRoomRequestList}
                    hotelList={true}
                    eventParticipants={
                        users.get().length > 0
                            ? users.attach(Downgraded).get()
                            : []
                    }
                    hotelInfo={
                        allHotelInfo.attach(Downgraded).get().length > 0
                            ? allHotelInfo.attach(Downgraded).get()
                            : null
                    }
                    ModuleType={1}
                />
            )}

            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.GREENROOM_LIST,
        component: GreenRoomList,
    },
    name: 'greenroom',
};